module.exports = __webpack_public_path__ + "static/media/GoalSetting.e96070bc.mp3";